import { applyMiddleware, createStore, compose } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import { routerMiddleware as createRouterMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import autoMerge from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import createCompressor from "redux-persist-transform-compress";

import { STATE_KEY as HOST_STATE_KEY } from "./components/Votify/VotifyHost/hostReducer";
import { STATE_KEY as PARTICIPANT_STATE_KEY } from "./components/Votify/VotifyParticipant/participantReducer";
import createRootReducer from "./rootReducer";

// Create a history of your choosing (we're using a browser history in this case)
const history = createBrowserHistory();

// Build the middleware for intercepting and dispatching navigation actions
const routerMiddleware = createRouterMiddleware(history);

// redux-persist config
const compressor = createCompressor();
const persistConfig = {
  key: "root",
  storage,
  stateReconciler: autoMerge, // stored state overwrites initial state only if stored key exists
  whitelist: [HOST_STATE_KEY, PARTICIPANT_STATE_KEY],
  transforms: [compressor],
};

const persistedReducer = persistReducer(
  persistConfig,
  createRootReducer(history),
);

const middleware =
  process.env.NODE_ENV === "development"
    ? composeWithDevTools(compose(applyMiddleware(thunk, routerMiddleware)))
    : applyMiddleware(thunk, routerMiddleware);

const store = createStore(persistedReducer, middleware);
const persistor = persistStore(store);

export { store, history, persistor };
